import { render, staticRenderFns } from "./MobileChat.vue?vue&type=template&id=f398f4a4&scoped=true"
import script from "./MobileChat.vue?vue&type=script&lang=js"
export * from "./MobileChat.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/chat.css?vue&type=style&index=0&id=f398f4a4&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f398f4a4",
  null
  
)

export default component.exports